module.exports = __webpack_public_path__ + "img/[蛋糕].dd843dc7.svg";